// extracted by mini-css-extract-plugin
export default {"cont":"styles_cont__tVa9I","deck":"styles_deck__FJTqt"};